﻿'use strict';

/*jslint bitwise: true */
angular.module('ntmApp').factory('UnderAllocatedStaff', ['ForecastService', 'UnderAllocatedStaffFilter', 'Constants', 'Utils', 'ForecastingFiltersProvider',
    function (ForecastService, UnderAllocatedStaffFilter, Constants, Utils, ForecastingFiltersProvider) {

    function UnderAllocatedStaff(forecastMode) {

        var self = this;
        self.forecastMode = forecastMode;
        self.staff = { items: [], filteredStaffItems: [] };

        self.Filter = new UnderAllocatedStaffFilter();
        self.filterDataSource = {};

        self.filterSettings = {
            displayProp: 'value',
            attachDisplayProp: true,
            smartButtonMaxItems: 5,
            scrollableHeight: '200px',
            enableSearch: true
        };

        self.multiSelectEvents = {
            onItemSelect: function () {
                self.performFiltering();
            },
            onItemDeselect: function () {
                self.performFiltering();
            },
            onDeselectAll: function () {
                self.performFiltering();
            }
        };

        self.load = function (header, selectedWeek, scenarioId) {

            var data = {
                forecastView: header.forecastOptionsSummary.forecastView,
                scope: header.selectedForecastScope.id.trim(),
                dateFrom: selectedWeek.startDate,
                dateTo: selectedWeek.endDate,
                forecastMode: self.forecastMode
            };

            if (scenarioId) {
                data.scenarioBreadcrumb = scenarioId;
            }

            self.loading = true;
            ForecastService.GetUnderAllocatedStaff(data).then(function (result) {

                if (result.success) {
                    self.staff.items = result.data.staff;
                    self.performFiltering();
                }

                self.staffContacts = getStaffContactsFilterDataSource();

                ForecastingFiltersProvider.LoadFilters().then(function (filters) {
                    if (filters) {
                        self.filterDataSource.roleFilters = filters.staffRoleFilters;
                        Utils.AddBlankOption(self.filterDataSource.roleFilters);
                    }
                    self.loading = false;
                });
            });
        };

        self.setFacilityAreaViewMode = function (viewMode) {
            self.forecastViewType = viewMode;
        };

        self.performFiltering = function () {
            self.staff.filteredStaffItems = self.Filter.performFiltering(self.staff.items);
        };

        self.toggleFilter = function () {
            self.showFilter = !self.showFilter;
        };

        self.clearAllFilters = function () {
            self.Filter.clearAllFilters();
            self.performFiltering();
        };

        self.clearFilter = function (filter) {
            filter.clear();
            self.performFiltering();
        };

        self.getStaffDayInfo = function (staffDay) {
            var dayLabel = Constants.DayLabels.getLabel(moment(staffDay.date));
            var info = Constants.StaffAttendTypes.isStaffPresent(staffDay.attendString) ? Utils.MinutesToHours(staffDay.available, 2) : Constants.StaffAttendTypes.formatStaffAttendType(staffDay.attendString);

            return "{0}: {1}".format(dayLabel, info);
        };

        self.isPTO = function (staffDay) {
            return Constants.StaffAttendTypes.isPTO(staffDay.attendString);
        };

        self.toggleItemSelection = function (current, items) {

            var newSelectionState = !current.isSelected;

            items.forEach(function (item) {
                item.isSelected = false;
            });

            current.isSelected = newSelectionState;
        };

        function getStaffContactsFilterDataSource() {

            var result = [];

            self.staff.items.forEach(function (staffItem) {
                result.push({
                    id: staffItem.personId,
                    value: staffItem.personName
                });
            });

            return result.unique(function (item1, item2) {
                return item1.id === item2.id;
            }).sort(function (item1, item2) {
                return item1.value.localeCompare(item2.value);
            });
        }
    }

    return (UnderAllocatedStaff);
}]);